import React from "react";
import ToastBox from "./ToastBox";
import { strings } from "assets/constants";
import { ToastConfigParams } from "react-native-toast-message";

const { successTitle, errorTitle, warningTitle, infoTitle } = strings;

type Props = {};
export const config = {
  success: (props: ToastConfigParams<Props>) => {
    const { text1, text2, type } = props;
    return (
      <ToastBox title={text1 || successTitle} message={text2} type={type} />
    );
  },
  error: (props: ToastConfigParams<Props>) => {
    const { text1, text2, type } = props;
    return <ToastBox title={text1 || errorTitle} message={text2} type={type} />;
  },
  warning: (props: ToastConfigParams<Props>) => {
    const { text1, text2, type } = props;
    return (
      <ToastBox title={text1 || warningTitle} message={text2} type={type} />
    );
  },
  info: (props: ToastConfigParams<Props>) => {
    const { text1, text2, type } = props;
    return <ToastBox title={text1 || infoTitle} message={text2} type={type} />;
  },
};
